<template>
  <div class="child-source w-100">
    <span class="source-label new-body-text">
      {{ atsSourceLabel === 'unknown' ? 'Unknown' : atsSourceLabel }}
    </span>
    <div class="submission-rate-chip-container">
      <SubmissionRateChip :fill-rate="fillRate" />
    </div>
    <div class="candidates-container">
      <span class="sources-count new-body-text">
        {{ typeof totalApplications === 'number' ? formatNumber(totalApplications) : '-' }}
      </span>
    </div>
  </div>
</template>

<script setup>
import SubmissionRateChip from '@/components/insights/ProcessInsights/DemographicSurveyReport/SubmissionRateChip.vue';
import { numberWithCommas } from '@/helpers/formatters';

defineProps({
  atsSourceLabel: { type: String, required: true },
  fillRate: { type: Number, required: true },
  totalApplications: { type: Number, required: true },
});

const formatNumber = (number) => numberWithCommas(number);
</script>

<script>
export default { name: 'SourceTable' };
</script>

<style lang="less" scoped>
.child-source {
  display: grid;
  grid-template-columns: minmax(200px, 505px) minmax(0, 200px) minmax(85px, 100px);

  .source-label {
    padding: 6px 12px 6px 40px;
    color: @text-light;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.submission-rate-chip-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
}

.sources-count {
  color: @text-lighter;
}

.candidates-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
